import React from "react";
import Logo from "../../assets/common/logo.png";
import "../getOffers/offers.scss";
import { Link } from "react-router-dom";
import MarryCard from "../../molecules/cards/MarryCard";
import VenorForm from "../../organisms/venorForm";
import eyes from "../../assets/view.png";
import comp from "../../assets/companies.png";
import devices from "../../assets/devices.png";
import gender from "../../assets/gender.png";
import graph from "../../assets/graph.png";

import likes from "../../assets/likes.png";
import visitors from "../../assets/visitors.png";

const Advertise = () => {
  const marryData = [
    {
      id: 1,
      title: "Tell us what you need",
      des: "Describe the service that you are looking for. We will match your request with vendors who can best meet your request.",
      img: "https://www.arabiaweddings.com/sites/default/files/uploads/2020/10/01/image1.png",
    },
    {
      id: 1,
      title: "Receive quotes and select a company",
      des: "Get quotes from trusted companies and professionals. Compare rates before hiring a service.",
      img: "https://www.arabiaweddings.com/sites/default/files/uploads/2020/10/01/image2.png",
    },
    {
      id: 1,
      title: "Sit back and relax",
      des: "Confirm the details of the product/service with the company you selected without the typical wedding planning stress.",
      img: "https://www.arabiaweddings.com/sites/default/files/uploads/2020/10/01/image3.png",
    },
  ];
  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-12 text-center d-flex justify-content-center">
            <Link to="/" className="logo_offers">
              <img src={Logo} alt="Logo" />
            </Link>
          </div>
        </div>
      </div>
      <div className="weird-landing-intro">
        <div className="container">
          <div className="row bg_map">
            <div className="col-md-6 ">
              <div className="text-center d-flex flex-column justify-content-center">
                <h1>
                  Advertise with Arabia Weddings and reach your potential
                  clients who are searching for wedding professionals today!
                </h1>
                <div className="text-center d-flex justify-content-center w-100">
                  <button>Get Started Now</button>
                </div>
              </div>
            </div>
            <div className="col-md-6"></div>
          </div>
        </div>
      </div>
      <div className="weird-landing-full-3">
        <div className="container">
          <div className="col-12 text-center d-flex justify-content-center">
            <div class="pane-content py-3">
              Arabia Weddings is the leading online wedding planning platform in
              the Middle East &amp; North Africa{" "}
            </div>
          </div>
        </div>
      </div>
      <div className="container my-4">
        <div className="row tools">
          <div class="col-md-3 col text-center-sm-6 text-center  col">
            <div class="icon">
              <img src={visitors} />
            </div>
            <div class="number">3.5 million</div>
            <div class="text">Yearly Visitors</div>
          </div>
          <div class="col-md-3 col text-center-sm-6 text-center  col">
            <div class="icon">
              <img src={eyes} />
            </div>
            <div class="number">8 million</div>
            <div class="text">Pageviews</div>
          </div>
          <div class="col-md-3 col text-center-sm-6 text-center  col">
            <div class="icon">
              <img src={likes} />
            </div>
            <div class="number">500,000</div>
            <div class="text">Social media fans</div>
          </div>
          <div class="col-md-3 col text-center-sm-6 text-center  col">
            <div class="icon">
              <img src={comp} />
            </div>
            <div class="number">15,000</div>
            <div class="text">Companies listed</div>
          </div>
        </div>
      </div>

      <div className="weird-landing-full-3">
        <div className="container">
          <div className="col-12 text-center d-flex justify-content-center">
            <div class="pane-content py-3">Our Users</div>
          </div>
        </div>
      </div>
      <div className=" users">
        <div className="container py-3 ">
          <div class="row">
            <div class="col-md-4 col">
              <div class="text">Gender</div>
              <div class="icon">
                <img src={gender} alt="graph" />
              </div>
            </div>

            <div class="col-md-4 col">
              <div class="text">Age Group</div>
              <div class="icon">
                <img src={graph} alt="graph" />
              </div>
            </div>

            <div class="col-md-4 col">
              <div class="text">They Browse From</div>
              <div class="icon">
                <img src={devices} alt="graph" />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12 text-center">
              <div class="text my-3 ">Top Countries</div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3 col text-center">
              <div class="">
                <img
                  src="https://www.arabiaweddings.com/sites/all/themes/arabiaweddings/images/landing2/map1.png"
                  alt="abc"
                />
              </div>
            </div>

            <div class="col-md-3 col text-center">
              <div class="">
                <img
                  alt="abc"
                  src="https://www.arabiaweddings.com/sites/all/themes/arabiaweddings/images/landing2/map2.png"
                />
              </div>
            </div>

            <div class="col-md-3 col text-center">
              <div class="">
                <img
                  alt="abc"
                  src="https://www.arabiaweddings.com/sites/all/themes/arabiaweddings/images/landing2/map3.png"
                />
              </div>
            </div>
            <div class="col-md-3 col text-center">
              <div class="">
                <img
                  alt="abc"
                  src="https://www.arabiaweddings.com/sites/all/themes/arabiaweddings/images/landing2/map4.png"
                />
              </div>
            </div>
          </div>
          <div class="row my-5">
            <div class="col-md-3 col text-center">
              <div class="">
                <img
                  alt="abc"
                  src="https://www.arabiaweddings.com/sites/all/themes/arabiaweddings/images/landing2/map5.png"
                />
              </div>
            </div>

            <div class="col-md-3 col text-center">
              <div class="">
                <img
                  alt="abc"
                  src="https://www.arabiaweddings.com/sites/all/themes/arabiaweddings/images/landing2/map6.png"
                />
              </div>
            </div>

            <div class="col-md-3 col text-center">
              <div class="">
                <img
                  alt="abc"
                  src="https://www.arabiaweddings.com/sites/all/themes/arabiaweddings/images/landing2/map7.png"
                />
              </div>
            </div>
            <div class="col-md-3 col text-center">
              <div class="">
                <img
                  alt="abc"
                  src="https://www.arabiaweddings.com/sites/all/themes/arabiaweddings/images/landing2/map8.png"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="weird-landing-full-3">
        <div className="container">
          <div className="col-12 text-center d-flex justify-content-center">
            <div class="pane-content py-3">Advertising Opportunities</div>
          </div>
        </div>
      </div>
      <div className="container Opportunities">
        <div class="row my-5">
          <div class="col-md-1 col">&nbsp;</div>

          <div class="col-md-2 col">
            <div class="text">
              Premium
              <br />
              Directory
              <br />
              Subscription
            </div>
          </div>

          <div class="col-md-2 col">
            <div class="text">
              Sponsored
              <br />
              Content
            </div>
          </div>

          <div class="col-md-2 col">
            <div class="text">
              Website
              <br />
              Banners
            </div>
          </div>

          <div class="col-md-2 col">
            <div class="text">EDM</div>
          </div>

          <div class="col-md-2 col">
            <div class="text">
              Social
              <br />
              Media
              <br />
              Posts
            </div>
          </div>

          <div class="col-md-1 col">&nbsp;</div>
        </div>
      </div>
      <div className="weird-landing-full-3">
        <div className="container">
          <div className="col-12 text-center d-flex justify-content-center">
            <div class="pane-content py-3">Details</div>
          </div>
        </div>
      </div>

 <div className="details">
        <div className="even">
          <div className="container ">
            <div class="row py-4">
              <div class="col-md-6">
                <h3>Premium Directory Subscription:</h3>
                <p>
                  Receive a full profile page with your contact details, links
                  to your website &amp; social media pages, images, videos… and
                  more. Subscription plans are available for 3, 6 and 12 month
                  periods. For details, <a href="#">click here</a>.
                </p>
              </div>
              <div class="col-md-6">
                <img src="https://www.arabiaweddings.com/sites/all/themes/arabiaweddings/images/landing2/s1.png" />
              </div>
            </div>
          </div>
        </div>
        <div class="odd">
          <div class="container">
            <div class="row py-4">
              <div class="col-md-6">
                <h3>Sponsored Content:</h3>
                <p>
                  Sponsored content is a great way to put your message across to
                  your potential clients in the form of an article published in
                  a relevant section on Arabia Weddings (eg fashion, beauty,
                  honeymoon… ).
                </p>
                <div class="rate">
                  <p>Rate starts from US$ 650 per article.</p>
                </div>
              </div>
              <div class="col-md-6">
                <img src="https://www.arabiaweddings.com/sites/all/themes/arabiaweddings/images/landing2/ss2.png" />
              </div>
            </div>
          </div>
        </div>
        <div class="even">
    <div class="container">
        <div class="row py-4">
            <div class="col-md-6">
                <h3>Website Banners:</h3>
                <p>Attract traffic to your website by placing an ad on Arabia Weddings. Banner sizes available are: Killer banner - 300 x 250px &amp; Leaderboard - 728 x 90px, in addition to special executions.</p>
                <div class="rate"><p>Rate:<br />
                    CPM = $30 targeted to one or all GCC markets (UAE, Saudi Arabia, Kuwait, Qatar, Bahrain, Oman)<br />
                    CPM = $15 targeted to Arab non GCC markets (Egypt, Jordan, Lebanon…)
                </p></div>
            </div>
            <div class="col-md-6">
                <img src="https://www.arabiaweddings.com/sites/all/themes/arabiaweddings/images/landing2/ss3.png" />
            </div>
        </div>
    </div>
</div>
<div class="odd">
    <div class="container">
        <div class="row py-4">
            <div class="col-md-6">
                <h3>EDM:</h3>
                <p>Promote your products/services directly to a list of targeted clients (either b-2-c or b-2-b) through our Electronic Direct Mail (EDM) system.</p>
<div class="rate"><p>Rate starts from US$ 550 per newsletter. </p>
</div>
            </div>
            <div class="col-md-6">
                <img src="https://www.arabiaweddings.com/sites/all/themes/arabiaweddings/images/landing2/ss4.png" />
            </div>
        </div>
    </div>
</div>
<div class="even">
    <div class="container">
        <div class="row py-4">
            <div class="col-md-6">
                <h3>Social Media Posts:</h3>
                <p>Reach thousands of potential clients through Social Media channels (Facebook, Instagram, Twitter). Your post will be placed on 3 channels and boosted to your target audience across the MENA region or to a specific location as desired.</p>
<div class="rate"><p>Rate starts from US$ 250 per post.
</p></div>
            </div>
            <div class="col-md-6">
                <img src="https://www.arabiaweddings.com/sites/all/themes/arabiaweddings/images/landing2/ss5.png" />
            </div>
        </div>
    </div>
</div>
        </div>
      <div className="container py-3 ">
        <div className="row">
          <div className="col-12">
            <VenorForm />
          </div>
        </div>
      </div>
    </>
  );
};

export default Advertise;
